import { ActiveGameButtonType, type ActiveGameData } from '@ps/web-poker-types';

import type { ActiveGamesState } from '../../types';

import { defaultState } from './activeGames';
import {
  mergeStoredActiveGameIds,
  removeStoredActiveGameIds,
  syncStoredActiveGameIds
} from './utils';

export const reducers = {
  add: (
    state: ActiveGamesState,
    payload: ActiveGamesState['games'] = defaultState.games
  ): ActiveGamesState => {
    const currentIds = new Set(state.games.map((game) => game.id));
    const newGames = payload.filter((game) => !currentIds.has(game.id));
    const updatedGames = [...state.games, ...newGames];

    syncStoredActiveGameIds(updatedGames.map((game) => Number(game.id)));

    return {
      ...state,
      games: updatedGames
    };
  },
  set: (
    state: ActiveGamesState,
    payload: ActiveGamesState['games'] = defaultState.games
  ): ActiveGamesState => {
    mergeStoredActiveGameIds(payload.map((game) => Number(game.id)));

    return {
      ...state,
      games: payload
    };
  },

  remove: (state: ActiveGamesState, payload: string[] = []): ActiveGamesState => {
    const idsToRemove = payload.map((id) => Number(id));
    const games: ActiveGameData[] = state.games.filter(
      (game) => !idsToRemove.includes(Number(game.id))
    );

    removeStoredActiveGameIds(idsToRemove);

    return {
      ...state,
      games
    };
  },

  clear: (state: ActiveGamesState): ActiveGamesState => ({
    ...state,
    games: []
  }),

  setTournamentInvite: (state: ActiveGamesState, payload: string): ActiveGamesState => {
    const targetId = Number(payload);

    const updatedGames = state.games.map((game) =>
      Number(game.id) === targetId
        ? { ...game, buttonType: ActiveGameButtonType.TAKE_SEAT, inviteReceivedAt: Date.now() }
        : game
    );

    return {
      ...state,
      games: updatedGames
    };
  }
};
